import React from 'react'
import { strings } from '../../../../localization/strings'
import routes from '../../../router/routes'
import { withRouter } from 'react-router-dom'

class Component extends React.Component {
    confirm = () => {
        this.props.history.push({
            pathname: routes.tracking.path,
            state: { orderId: this.props.orderId },
        })
    }

    render() {
        return (
            <div style={{ width: '100%' }}>
                <div onClick={this.confirm}>{strings.viewOrderButton}</div>
            </div>
        )
    }
}

export default withRouter(Component)
